import { useProject } from '@customink/project-service-react-components';
import { SHIPPING_TYPES } from '@customink/project-service-types';

import { rollbar } from '@/config/rollbar.config';
import { useInternalPreview } from '@/hooks/internalPreview';

export function useCheckoutUrl() {
  const { data: project } = useProject();
  const isInternalPreview = useInternalPreview();

  // If in internal preview mode and there are project items, use the first item's design CID
  // to construct the internal checkout URL
  if (isInternalPreview && project?.items?.length) {
    const firstItem = project.items[0];
    const designCid = firstItem.design?.cid;

    if (designCid) {
      return `${
        import.meta.env.PROJECT_SERVICE_INTERNAL_CHECKOUT_URL
      }?cid=${designCid}&resume_draft_order=true`;
    }
  }

  const deliveryMode = {
    [SHIPPING_TYPES.BULK]: '',
    [SHIPPING_TYPES.INDIVIDUAL]: 'distributed',
  }[project?.configuration?.shippingType || SHIPPING_TYPES.BULK];

  if (!project?.coreOrder?.checkoutUrl) {
    return '';
  }

  try {
    const checkoutUrl = new URL(project.coreOrder.checkoutUrl);
    const params = new URLSearchParams(checkoutUrl.search);

    if (deliveryMode) {
      params.set('deliveryMode', deliveryMode);
    }

    checkoutUrl.search = params.toString();
    return checkoutUrl.toString();
  } catch (err) {
    rollbar.error(
      'Error generating checkout URL',
      err,
      project?.coreOrder?.checkoutUrl,
    );
    return '';
  }
}
